import { render, staticRenderFns } from "./LoadFileList.vue?vue&type=template&id=b38af9d8&scoped=true"
import script from "./LoadFileList.vue?vue&type=script&lang=ts"
export * from "./LoadFileList.vue?vue&type=script&lang=ts"
import style0 from "./LoadFileList.vue?vue&type=style&index=0&id=b38af9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38af9d8",
  null
  
)

export default component.exports